import { makeAutoObservable } from "mobx";
import ApiStore from "./ApiStore";
import { PaymentSystem } from "../api/CountryPaymentSystemApiClient";

class CountryPaymentSystemStore {
    availableSystems: PaymentSystem[] = [];
    isLoading: boolean = true;

    ApiStore!: ApiStore;

    constructor(apiStore: ApiStore) {
        makeAutoObservable(this);
        this.ApiStore = apiStore;
    }

    GetAllAvailablePaymentSystems = async (countryId: number) => {
        this.isLoading = true;
        try {
            const availableSystems = await this.ApiStore.CountryPaymentSystemApiClient.GetAllAvailablePaymentSystems(countryId);
            this.availableSystems = availableSystems;
        } catch (error) {
            console.error("Error fetching available payment systems:", error);
        } finally {
            this.isLoading = false;
        }
    };
}

export default CountryPaymentSystemStore;
